// Supervision générique Worker Admin — GET /admin/supervision (OPAQUE)
// ≠ /admin/supervision/indicateurs (Paiement)
import React, { useCallback, useEffect, useState } from 'react';
import { RefreshCw, ShieldAlert, Activity } from 'lucide-react';
import { getSupervision } from '../../services/adminSupervision';

export default function SupervisionTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getSupervision();
      setData(res);
    } catch (err) {
      setData(null);
      setError(
        err?.status === 403
          ? 'Vous n’avez pas l’autorisation de consulter la supervision.'
          : err?.message || 'Impossible de charger la supervision.'
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // Présentation opaque : services connus avec valeur null ou objet
  const services =
    data && typeof data === 'object' && !Array.isArray(data)
      ? Object.entries(data).filter(([k]) => !k.startsWith('_'))
      : [];

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap justify-between gap-2 items-center">
        <div>
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
            <Activity size={16} className="text-indigo-600" /> Supervision Admin
          </h3>
          <p className="text-[11px] text-slate-500 mt-0.5">
            État récemment signalé par chaque service de la plateforme.
          </p>
        </div>
        <button type="button" className="dsi-btn-secondary text-xs" onClick={load} disabled={loading}>
          <RefreshCw size={14} className={loading ? 'animate-spin' : ''} /> Actualiser
        </button>
      </div>

      {error && (
        <div className="p-3 rounded-2xl bg-rose-50 border border-rose-200 text-rose-800 text-xs font-bold flex gap-2">
          <ShieldAlert size={14} /> {error}
        </div>
      )}

      {loading ? (
        <div className="dsi-card p-10 text-center text-xs text-slate-500">Chargement…</div>
      ) : !data ? (
        <div className="dsi-card p-10 text-center text-xs text-slate-500">Aucune information de supervision pour le moment.</div>
      ) : services.length === 0 ? (
        <div className="dsi-card p-6">
          <pre className="text-[11px] overflow-x-auto whitespace-pre-wrap text-slate-700">
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {services.map(([name, value]) => (
            <div key={name} className="dsi-card p-4 space-y-2">
              <p className="text-xs font-bold text-slate-900 uppercase tracking-wide">{name}</p>
              {value === null || value === undefined ? (
                <p className="text-xs text-slate-400">Aucune donnée disponible pour ce service.</p>
              ) : (
                <pre className="text-[10px] text-slate-600 overflow-x-auto max-h-48 whitespace-pre-wrap bg-slate-50 rounded-xl p-2 border border-slate-100">
                  {typeof value === 'string' ? value : JSON.stringify(value, null, 2)}
                </pre>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
